const isHostOrSubdomain = (hostname, domain) =>
  Boolean(domain) && (hostname === domain || hostname.endsWith(`.${domain}`));

export const isAllowedRedirect = (href, { origin, domain }) => {
  let url;
  let page;
  try {
    page = new URL(origin);
    url = new URL(href, page);
  } catch (e) {
    return false;
  }
  // http is accepted only when the page itself is http (local dev)
  const isAllowedProtocol = url.protocol === 'https:' || url.protocol === page.protocol;
  const isAllowedHost = url.host === page.host || isHostOrSubdomain(url.hostname, domain);
  return isAllowedProtocol && isAllowedHost;
};
